/*eslint-disable */

export default {
  updatePassionProjectResponse(context, payload) {
    return new Promise((resolve, reject) => {
      try {
        context.commit("setPassionProjectResponse", payload);
        resolve();
      } catch (err) {
        reject(err);
      }
    });
  },
  removePassionProjectResponse(context) {
    return new Promise((resolve, reject) => {
      try {
        context.commit("removePassionProjectResponse");
        resolve();
      } catch (err) {
        reject(err);
      }
    });
  }
}